import { createSlice } from "@reduxjs/toolkit";
import { REQUEST_STATUS } from "../../../../functions/constants";
import {
  fetchTicketByIdThunk,
  taskAcceptThunk,
  taskCompleteThunk,
  updateTicketByIdThunk,
} from "./currentTicketOperations";

const slice = createSlice({
  name: "currentTicket",
  initialState: {
    // request lifecycle: idle | loading | succeeded | failed
    status: REQUEST_STATUS.IDLE,
    error: null,
    ticketManagerTaskIsLoading: false,
  },
  reducers: {
    // Reset state to initial (status back to idle, clear errors and transient flags)
    resetCurrentTicket: () => ({
      status: REQUEST_STATUS.IDLE,
      error: null,
      ticketManagerTaskIsLoading: false,
    }),
  },
  extraReducers: (builder) => {
    // fetch ticket
    builder.addCase(fetchTicketByIdThunk.pending, (state) => {
      state.status = REQUEST_STATUS.LOADING;
      state.error = null;
    });
    builder.addCase(fetchTicketByIdThunk.fulfilled, (state, action) => {
      Object.assign(state, action.payload);
      state.status = REQUEST_STATUS.SUCCEEDED;
      state.error = null;
    });
    builder.addCase(fetchTicketByIdThunk.rejected, (state, action) => {
      state.status = REQUEST_STATUS.FAILED;
      state.error = action.error?.message || null;
    });

    // update ticket
    builder.addCase(updateTicketByIdThunk.pending, (state) => {
      state.status = REQUEST_STATUS.LOADING;
      state.error = null;
    });
    builder.addCase(updateTicketByIdThunk.rejected, (state, action) => {
      state.status = REQUEST_STATUS.FAILED;
      state.error = action.error?.message || null;
    });
    builder.addCase(updateTicketByIdThunk.fulfilled, (state, action) => {
      Object.assign(state, action.payload);
      state.status = REQUEST_STATUS.SUCCEEDED;
      state.error = null;
    });
    // specific ticket-manager operations
    // accept ticket
    builder.addCase(taskAcceptThunk.pending, (state) => {
      state.ticketManagerTaskIsLoading = true;
    });
    builder.addCase(taskAcceptThunk.fulfilled, (state) => {
      state.ticketManagerTaskIsLoading = false;
    });
    // complete ticket
    builder.addCase(taskCompleteThunk.pending, (state) => {
      state.ticketManagerTaskIsLoading = true;
    });
    builder.addCase(taskCompleteThunk.fulfilled, (state) => {
      state.ticketManagerTaskIsLoading = false;
    });
  },
});

const selectSelf = (state) => state.tickets.ticketDetail.currentTicket;
const selectCurrentTicket = (state) => selectSelf(state);
const selectCurrentTicketStatus = (state) => selectSelf(state).status;
const selectCurrentTicketError = (state) => selectSelf(state).error;

export const currentTicketSelectors = {
  selectCurrentTicket,
  selectCurrentTicketStatus,
  selectCurrentTicketError,
};

export const { resetCurrentTicket } = slice.actions;

export const reducer = slice.reducer;
